import React, { useState } from "react";
import { auth } from '../../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo/logo.png';
import { Helmet } from "react-helmet";

const CreateAccount = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const getCreateAccountError = (code) => {
        switch (code) {
            case "auth/email-already-in-use":
                return "This email is already registered. Please use a different email or login.";
            case "auth/invalid-email":
                return "Invalid email address format.";
            case "auth/weak-password":
                return "Password should be at least 6 characters.";
            case "auth/operation-not-allowed":
                return "Account creation is currently disabled. Please contact support.";
            default:
                return "Account creation failed. Please try again.";
        }
    };
    const handleCreateAccount = async (e) => {
        e.preventDefault();
        setError("");
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        setLoading(true);
        try {
            await createUserWithEmailAndPassword(auth, username, password);
            navigate('/apply');
        } catch (err) {
            setError(getCreateAccountError(err.code));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>AIA| LOGIN | AAS</title>
                <meta name="description" content="Sign up to the Arthur Application System (AAS) to apply and track your study applications, scholarships, and university opportunities." />
            </Helmet>
            <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', paddingTop: 80, paddingBottom: 40 }}>
                <div className="header" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1e3c72 100%)',
                    color: '#fff',
                    padding: '12px 20px',
                    zIndex: 1001,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                    borderBottom: '2px solid #4a90e2',
                    flexWrap: 'wrap',
                }}>
                    {/* Logo and Title */}
                    <div style={{
                        display: 'flex',
                        // alignItems: 'center',
                        gap: '16px',
                        margin: '0 auto'
                    }}>
                        <img src={logo} alt="logo" width="55px" style={{
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                            border: '2px solid #4a90e2',
                            backgroundColor: '#ffffff'
                        }} />
                        <h1 style={{
                            color: "#ffffff",
                            margin: 0,
                            fontSize: '1.8rem',
                            fontWeight: '700',
                            // textAlign: 'center',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                            letterSpacing: '1px',
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                        }}>
                            ARTHUR APPLICATION SYSTEM (AAS)
                        </h1>
                    </div>
                </div>
                <br />
                <div className="login-container" style={{ maxWidth: 400, margin: "40px auto", padding: 24, borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", background: "#fff" }}>
                    <h1 style={{ textAlign: "center", marginBottom: 24 }}>Create Account</h1>
                    {error && (
                        <div style={{ color: 'red', marginBottom: 12, textAlign: 'center' }}>{error}</div>
                    )}
                    <form className="login-form" onSubmit={handleCreateAccount} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                        <label style={{ fontWeight: 500 }}>
                            email
                            <input
                                type="text"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                required
                                style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
                                placeholder="Enter your email"
                            />
                        </label>
                        <label style={{ fontWeight: 500, position: "relative" }}>
                            Password
                            <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                    style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
                                    placeholder="Enter your password"
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{ position: "absolute", right: 12, top: 14, cursor: "pointer", userSelect: "none" }}
                                    title={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? (
                                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9.27-3.11-11-7.5C3.11 7.11 7.38 4 12 4c1.13 0 2.22.13 3.25.375M19.07 4.93l-14.14 14.14M9.88 9.88A3 3 0 0114.12 14.12" /></svg>
                                    ) : (
                                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm7.5 0c-1.73 4.39-6 7.5-10.5 7.5S2.23 16.39.5 12C2.23 7.61 6.5 4.5 12 4.5s9.27 3.11 11 7.5z" /></svg>
                                    )}
                                </span>
                            </div>
                        </label>
                        <label style={{ fontWeight: 500, position: "relative" }}>
                            Confirm Password
                            <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value)}
                                    required
                                    style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
                                    placeholder="confirm password"
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{ position: "absolute", right: 12, top: 14, cursor: "pointer", userSelect: "none" }}
                                    title={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? (
                                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9.27-3.11-11-7.5C3.11 7.11 7.38 4 12 4c1.13 0 2.22.13 3.25.375M19.07 4.93l-14.14 14.14M9.88 9.88A3 3 0 0114.12 14.12" /></svg>
                                    ) : (
                                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm7.5 0c-1.73 4.39-6 7.5-10.5 7.5S2.23 16.39.5 12C2.23 7.61 6.5 4.5 12 4.5s9.27 3.11 11 7.5z" /></svg>
                                    )}
                                </span>
                            </div>
                        </label>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, marginBottom: 8 }}>
                            <a href="/login" style={{ fontSize: 14, color: '#007bff', textDecoration: 'none' }}>you have an account? login</a>
                        </div>
                        <button type="submit" style={{ padding: 10, borderRadius: 6, background: "#007bff", color: "#fff", fontWeight: 600, border: "none", marginTop: 8, display: loading ? 'none' : 'block' }}>Create Account</button>
                    </form>
                    {loading && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    {/* <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 24 }}>
                <button onClick={handleGoogleLogin} style={{ padding: 10, borderRadius: 6, background: "#fff", color: "#333", fontWeight: 600, border: "1px solid #ccc", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                    <svg width="20" height="20" viewBox="0 0 48 48"><g><path fill="#4285F4" d="M44.5 20H24v8.5h11.7C34.7 33.1 29.8 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.7 0 5.2.9 7.2 2.4l6.4-6.4C33.5 5.1 28.1 3 24 3 12.9 3 4 11.9 4 23s8.9 20 20 20c11.1 0 19.7-7.9 19.7-19 0-1.3-.1-2.3-.2-3z"/><path fill="#34A853" d="M6.3 14.7l7 5.1C15.1 17.1 19.2 14 24 14c2.7 0 5.2.9 7.2 2.4l6.4-6.4C33.5 5.1 28.1 3 24 3 15.3 3 7.9 8.6 6.3 14.7z"/><path fill="#FBBC05" d="M24 44c5.8 0 10.7-1.9 14.3-5.1l-6.6-5.4C29.8 36 24 36 24 36c-5.8 0-10.7-1.9-14.3-5.1l6.6-5.4C18.2 30.9 22.3 34 24 34z"/><path fill="#EA4335" d="M44.5 20H24v8.5h11.7C34.7 33.1 29.8 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.7 0 5.2.9 7.2 2.4l6.4-6.4C33.5 5.1 28.1 3 24 3 12.9 3 4 11.9 4 23s8.9 20 20 20c11.1 0 19.7-7.9 19.7-19 0-1.3-.1-2.3-.2-3z"/></g></svg>
                    Login with Google
                </button>
                <button onClick={handleICloudLogin} style={{ padding: 10, borderRadius: 6, background: "#fff", color: "#333", fontWeight: 600, border: "1px solid #ccc", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                    <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#000" d="M16.5 13.5c-.2 0-.3 0-.5.1-.2-.6-.7-1-1.3-1-.2 0-.4.1-.6.2-.2-.7-.8-1.3-1.6-1.3-.7 0-1.3.5-1.5 1.1-.2-.1-.4-.1-.6-.1-.7 0-1.3.6-1.3 1.3 0 .2 0 .3.1.5-.6.2-1 .7-1 1.3 0 .8.7 1.5 1.5 1.5h7c.8 0 1.5-.7 1.5-1.5 0-.7-.5-1.3-1.2-1.4zM15.5 8c-.2 0-.4 0-.6.1-.2-.7-.8-1.3-1.6-1.3-.7 0-1.3.5-1.5 1.1-.2-.1-.4-.1-.6-.1-.7 0-1.3.6-1.3 1.3 0 .2 0 .3.1.5-.6.2-1 .7-1 1.3 0 .8.7 1.5 1.5 1.5h7c.8 0 1.5-.7 1.5-1.5 0-.7-.5-1.3-1.2-1.4z"/></svg>
                    Login with iCloud
                </button>
            </div> */}
                </div>
                <footer style={{ textAlign: 'center', marginTop: 40, color: '#fff' }}>
                    &copy; {new Date().getFullYear()} Arthur International Agency. All rights reserved.
                </footer>
            </div>
        </>
    );
};

export default CreateAccount;